/**
 * kavalio custom collection scripts (Filters & Sorting)
 */

// Grundfarbe Filter JS
(function () {
  var FILTER_ID = "facet-filter-filter.v.m.custom.grundfarbe";
  var INPUT_SELECTOR = "#" + CSS.escape(FILTER_ID) + " .checkbox-container .checkbox";
  var scheduled = false;

  function getFallbackLabelText(label) {
    if (!label) return "";
    var text = (label.textContent || "").trim();
    return text.replace(/\s*\(\d+\).*/, "").trim();
  }

  function applyGrundfarbeTooltipLabels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var inputs = scope.querySelectorAll(INPUT_SELECTOR);

    inputs.forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label || label.tagName !== "LABEL") return;

      var tooltipLabel = (input.value || "").trim() || getFallbackLabelText(label);
      if (!tooltipLabel) return;

      if (label.getAttribute("data-tooltip-label") !== tooltipLabel) {
        label.setAttribute("data-tooltip-label", tooltipLabel);
      }
    });
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      applyGrundfarbeTooltipLabels(document);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      applyGrundfarbeTooltipLabels(document);
    });
  } else {
    applyGrundfarbeTooltipLabels(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    applyGrundfarbeTooltipLabels(event && event.target ? event.target : document);
  });

  var observer = new MutationObserver(function () {
    scheduleApply();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
// END:Grundfarbe Filter JS


// START: Collection price sort
(function () {
  var PRICE_SORT_VALUES = ["price-ascending", "price-descending"];
  var facetMainObserver = null;

  function getActivePriceSort() {
    var sortBy = new URLSearchParams(window.location.search).get("sort_by");
    return PRICE_SORT_VALUES.indexOf(sortBy) !== -1 ? sortBy : null;
  }

  function resortCollectionPriceSort() {
    var sortBy = getActivePriceSort();
    if (!sortBy) return;

    var inner = document.querySelector(".product-facet .product-list__inner");
    if (!inner) return;

    var children = Array.from(inner.children);
    if (children.length < 2) return;

    var ascending = sortBy === "price-ascending";
    var slots = children.map(function (el, index) {
      var raw = el.getAttribute("data-sort-price");
      return {
        el: el,
        index: index,
        isProduct: raw !== null && raw !== "",
        sortPrice: parseInt(raw, 10) || 0,
      };
    });

    if (!slots.some(function (slot) { return slot.isProduct; })) return;

    var sortedProducts = slots
      .filter(function (slot) { return slot.isProduct; })
      .slice()
      .sort(function (a, b) {
        var diff = ascending ? a.sortPrice - b.sortPrice : b.sortPrice - a.sortPrice;
        return diff !== 0 ? diff : a.index - b.index;
      });

    var productIndex = 0;
    var targetOrder = slots.map(function (slot) {
      return slot.isProduct ? sortedProducts[productIndex++].el : slot.el;
    });

    // Idempotent: skip DOM work (and any observer churn) when already ordered.
    var alreadySorted = targetOrder.every(function (el, i) {
      return children[i] === el;
    });
    if (alreadySorted) return;

    targetOrder.forEach(function (el) {
      inner.appendChild(el);
    });
  }

  function scheduleResort() {
    requestAnimationFrame(resortCollectionPriceSort);
  }

  function observeFacetMain() {
    var main = document.querySelector("product-facet #facet-main");
    if (!main) return;

    if (facetMainObserver) facetMainObserver.disconnect();
    facetMainObserver = new MutationObserver(scheduleResort);
    facetMainObserver.observe(main, { childList: true });
  }

  function init() {
    observeFacetMain();
    resortCollectionPriceSort();
  }

  window.KavalioCollectionPriceSort = resortCollectionPriceSort;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("facet:criteria-changed", scheduleResort);

  document.addEventListener("shopify:section:load", function () {
    observeFacetMain();
    scheduleResort();
  });
})();
// END: Collection price sort
